import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import CircularProgress from '@material-ui/core/CircularProgress';
import CountUp from 'react-countup';
import Button from '@material-ui/core/Button';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import PropTypes from 'prop-types';

import {Link} from 'react-router-dom'
import BackIcon from '@material-ui/icons/ArrowBack';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import SiriWave from '../components/siriwave';
import p5 from 'p5';
import 'p5/lib/addons/p5.sound';
import MedelPaper from "../components/MedelPaper";

import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';
import VolumeDown from '@material-ui/icons/VolumeDown';
import VolumeUp from '@material-ui/icons/VolumeUp';
import {Link as mLink} from '@material-ui/icons/Link';
import {interimSubmit, redirectToHome} from '../components/Helpers';
import Auth from "../components/Auth";
import {withTranslation, Trans} from 'react-i18next';
import TestMode from "../components/TestMode";
import i18n from "i18next";

const auth = new Auth();


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        textAlign: 'left',
        fontSize: '16px',
        fontWeight: 600,
    },
    space: {
        padding: theme.spacing(1.5, 3),
    },

    marginL: {
        marginRight: theme.spacing(1),
    },
});

const SNR = [-14, -12, -10, -8, -6, -4, -2, 0, 2, 4, 6, 8, 10];


function ElevationScroll(props) {
    const {children, window} = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};
let songsArray = [];
let analyzer;
let clicked;


class TrippleDigitTest extends Component {

    constructor(props) {
        super(props);

        //EDIT HERE
        this.rounds = 3;
        this.sketch = true;
        this.index = 0;
        this.successsound = false;
        this.unmount = false;
        this.totalAnswers = 0;
        this.answerGiven = 0;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.SNRs = [];
        this.SNRmaxIndex = SNR.length - 1;
        this.curSound = false;
        this.inputNoticeTimeout = false;
        this.state = {
            trippletest: localStorage.getItem('medel-tripple') ? true : false,
            amplitude: 0,
            disabled: false,
            next: false,
            isLoading: true,
            startTest: false,
            curIndex: 0,
            curSNR: 4,
            curSNRIndex: 9,
            finishedTest: false,
            percentage: 0,
            setOpen: false,
            tracklist: {},
            sketch: false,
            input: '',
            correct: 0,
            false: 0,
            avgSNR: 0,
            SNRs: [],
            noiseLevelOK: true,
            countdown: false,
            showInputNotice: false,
            detailArray: {track: '', details: []},
            volume: parseInt(localStorage.getItem(this.user.sub + '-medel-volume' + ('_' + localStorage.getItem('med-curEar')))),
            showBlurDialog: false
        };

        const {t, i18n} = this.props;

        this.lang = window._remotecheck_config.trippleDigitLanguages.includes(i18n.language) ? i18n.language : 'en-GB';
    }


    updatePerc = () => {
        let perc = this.answerGiven / this.totalAnswers;
        document.getElementById('percentage').style.width = ((100 * (perc))) + '%';

        let tmpper = Math.round(perc * 100);
        this.state.percentage = Math.round(perc * 100);
        this.setState({percentage: this.state.percentage})
    };

    componentWillUnmount() {
        this.unmount = true;
        delete this.sketch;
        clearTimeout(this.timeout);
        clearInterval(this.interval);
        if (this.mic) {
            clearInterval(this.micInterval);
            this.mic.stop();
        }
        if (this.curSound && this.curSound.isPlaying()) {
            this.curSound.stop();
            this.curSound.clearCues();
        }


    }

    onBlur = () => {
        if (this.curSound && this.curSound.isPlaying()) {
            this.curSound.stop();
            this.setState({showBlurDialog: true});
        }
    };

    clickHandlerBlur = () => {
        if (this.curSound) {
            this.curSound.play();
            this.setState({showBlurDialog: false});
        }
    }


    handleClick = (index) => {

        clearTimeout(this.inputNoticeTimeout);
        this.state.input = "" + this.state.input;
        if (this.state.input.length < 3 && Number.isInteger(index)) {
            this.setState({...this.state, input: "" + this.state.input + "" + index, showInputNotice: false,}, () => {
                this.state.input = "" + this.state.input;
                this.setState({...this.state, next: (this.state.input.length === 3)});
            });
            clicked = false;
        } else if (this.state.input.length > 0 && index === 'back') {
            this.setState({
                ...this.state,
                input: this.state.input.substring(0, this.state.input.length - 1),
                showInputNotice: false,
            }, () => {
                this.state.input = "" + this.state.input;
                this.setState({...this.state, next: (this.state.input.length === 3)});
            });

        } else if (this.state.input.length === 3 && index === 'next') {
            this.setState({...this.state, countdown: false, showInputNotice: false});

            this.answerGiven++;

            this.updatePerc();


            this.state.SNRs.push(parseInt(SNR[this.state.curSNRIndex]));
            let total = 0;

            if (this.state.SNRs.length >= 4) {
                for (let i = 3; i < this.state.SNRs.length; i++) {
                    total += this.state.SNRs[i];
                }

                this.state.avgSNR = total / (this.state.SNRs.length - 3);

                if (this.state.avgSNR >= 8) {
                    this.state.avgSNR = 8;
                }

            } else {
                this.state.avgSNR = 0;
            }
            this.setState((state, props) => {

                return {avgSNR: this.state.avgSNR}
            }, () => {

                if ((this.state.input.toString()).trim() === (this.curTrack[this.state.curIndex].toString()).trim()) {

                    this.state.detailArray.details.push({
                        value: (this.curTrack[this.state.curIndex].toString()).trim(),
                        correct: true,
                        SNR: SNR[this.state.curSNRIndex],
                        input: this.state.input.toString().trim()
                    })

                    this.setState({
                        ...this.state,
                        correct: ++this.state.correct,
                        false: this.state.false,
                        SNRs: this.state.SNRs,
                        avgSNR: this.state.avgSNR,
                        countdown: false,
                        detailArray: this.state.detailArray
                    }, () => {
                        if (this.curTrack[this.state.curIndex + 1]) {
                            this.setState({
                                ...this.state,
                                curIndex: this.state.curIndex + 1,
                                curSNRIndex: this.state.curSNRIndex > 0 ? this.state.curSNRIndex - 1 : 0,
                                curSNR: SNR[this.state.curSNRIndex > 0 ? this.state.curSNRIndex - 1 : 0]
                            }, () => {
                                this.setState({...this.state, next: false, disabled: false, countdown: false});
                                document.querySelector('.testMain').classList.remove('inputshow');
                                this.curSound = p5.prototype.loadSound(this.state.tracklist['_' + this.curTrack[this.state.curIndex]].sounds['_' + this.state.curSNR].sound, () => {
                                    analyzer.setInput(this.curSound);

                                    this.curSound.onended((e) => {

                                        if (document.querySelector('.testMain')) {
                                            document.querySelector('.testMain').classList.add('inputshow');
                                            this.setState({...this.state, disabled: false, countdown: true});
                                        }

                                        clearTimeout(this.inputNoticeTimeout);
                                        this.inputNoticeTimeout = setTimeout(() => {
                                            this.setState({showInputNotice: true})
                                        }, 3000)
                                    });
                                    this.curSound.setVolume(parseInt(localStorage.getItem(this.user.sub + '-medel-volume' + ('_' + localStorage.getItem('med-curEar')))) / 100);
                                    this.curSound.pan(localStorage.getItem('med-curEar') === 'left' ? -1.0 : 1.0);

                                    this.curSound.play();
                                    this.setState({...this.state, input: '', next: false, disabled: false});
                                });

                            });
                        } else {
                            this.handleFinish();
                        }
                    });


                } else {

                    this.state.detailArray.details.push({
                        value: (this.curTrack[this.state.curIndex].toString()).trim(),
                        correct: false,
                        SNR: SNR[this.state.curSNRIndex],
                        input: this.state.input.toString().trim()
                    })

                    this.setState({
                        ...this.state,
                        correct: this.state.correct,
                        false: this.state.false + 1,
                        SNRs: this.state.SNRs,
                        avgSNR: this.state.avgSNR,
                        detailArray: this.state.detailArray,
                        showInputNotice: false,
                    }, () => {
                        if (this.state.curSNRIndex < this.SNRmaxIndex && this.curTrack[this.state.curIndex + 1]) {
                            this.setState({
                                ...this.state,
                                curIndex: this.state.curIndex + 1,
                                curSNRIndex: this.state.curSNRIndex + 1,
                                curSNR: SNR[this.state.curSNRIndex + 1]
                            }, () => {
                                this.setState({...this.state, next: false, disabled: false, countdown: false});
                                document.querySelector('.testMain').classList.remove('inputshow');
                                this.curSound = p5.prototype.loadSound(this.state.tracklist['_' + this.curTrack[this.state.curIndex]].sounds['_' + this.state.curSNR].sound, () => {
                                    analyzer.setInput(this.curSound);

                                    this.curSound.onended((e) => {

                                        if (document.querySelector('.testMain')) {
                                            document.querySelector('.testMain').classList.add('inputshow');
                                            this.setState({...this.state, disabled: false, countdown: true});

                                            clearTimeout(this.inputNoticeTimeout);
                                            this.inputNoticeTimeout = setTimeout(() => {
                                                this.setState({showInputNotice: true})
                                            }, 3000)
                                        }

                                    });
                                    this.curSound.setVolume(parseInt(localStorage.getItem(this.user.sub + '-medel-volume' + ('_' + localStorage.getItem('med-curEar')))) / 100);
                                    this.curSound.pan(localStorage.getItem('med-curEar') === 'left' ? -1.0 : 1.0);

                                    this.curSound.play();
                                    this.setState({
                                        ...this.state,
                                        input: '',
                                        next: false,
                                        disabled: false,
                                        countdown: false
                                    });
                                });

                            });
                        } else if(this.state.curSNRIndex >= this.SNRmaxIndex ){
                            this.setState({...this.state, avgSNR: 8}, () => {
                                this.handleFinish('red');
                            });
                        }else{
                            this.setState({...this.state, avgSNR: this.state.avgSNR}, () => {
                                this.handleFinish();
                            });
                        }

                    });


                }
            });




        }

    };

    handleFinish = async (result) => {

        this.setState({...this.state, finishedTest: parseInt(Date.now() / 1000)});
        clearTimeout(this.inputNoticeTimeout);

        result = 'red';

        if (this.state.avgSNR < -7.1) {
            result = 'green';
        } else if (this.state.avgSNR < -5.1) {
            result = 'yellow';
        }


        let finishObject = {
            SNRs: this.state.SNRs,
            correct: this.state.correct,
            false: this.state.false,
            avgSNR: this.state.avgSNR,
            result: result
        }

        this.user = JSON.parse(localStorage.getItem('user'));

        if (this.user) {
            await localStorage.setItem(this.user.sub + '-medel-tripple' + ('_' + localStorage.getItem('med-curEar')), JSON.stringify([finishObject, this.state.detailArray, {
                volume: parseInt(localStorage.getItem(this.user.sub + '-medel-volume' + ('_' + localStorage.getItem('med-curEar')))),
                patient_start_test: this.state.startTest,
                patient_end_test: parseInt(Date.now() / 1000)
            }]));
            let resp = await interimSubmit();
            redirectToHome();
        }


    };

    handleClickOpen = () => {
        if (!this.state.startTest) {
            window.location.href = '/';
        } else {
            this.setState({...this.state, setOpen: true});
        }
    };

    handleClose = () => {
        this.setState({...this.state, setOpen: false});
    };


    startCountdown = (cb) => {

        let counter = 3;
        this.countdownSound.pan(localStorage.getItem('med-curEar') === 'left' ? -1.0 : 1.0);
        this.countdownSound.play();
        this.countdownSound.setVolume(parseInt(localStorage.getItem(this.user.sub + '-medel-volume' + ('_' + localStorage.getItem('med-curEar')))) / 100);
        document.getElementById('countdownbignumber').innerHTML = counter;
        document.getElementById('countdownbig').style.strokeDashoffset = 630;
        this.timeout = setTimeout(() => {
            this.interval = setInterval(() => {
                counter -= 0.025;

                document.getElementById('countdownbignumber').innerHTML = Math.round(counter);
                document.getElementById('countdownbig').style.strokeDashoffset = 630 - (630 - (630 * (counter / 5)));


                if (counter <= 0) {
                    clearInterval(this.interval);

                    if (cb) {
                        cb();
                    }
                }
            }, 25);
        }, 500)
    };

    componentDidMount() {

        this.siriWave = new SiriWave({
            container: document.getElementById('siri-container-2'),
            width: window.innerWidth - 60,
            height: (window.innerWidth - 60) * 0.4,
            autostart: true,
            color: '#000',
            speed: 0.2,
            amplitude: 0.00000001,
        });

        this.meterdiv = document.getElementById('meter-container');

        document.getElementById('percentage').style.width = '0%';

        this.track = Math.round(Math.random() * 10);

        if (this.track === 0) {
            this.track = Math.round(Math.random() * 10);
            if (this.track === 0) {
                this.track = Math.round(Math.random() * 10);
                if (this.track === 0) {
                    this.track = 1
                }
            }
        }

        this.setState({detailArray: {track: this.track, details: []}});

        setTimeout(() => {
            fetch('/sounds/trippleDigit/list/digit3.' + this.track + '.txt')
                .then((response) => {
                    return response.text();
                })
                .then((curTrack) => {
                    this.curTrack = curTrack.split("\n");

                    this.curTrack = this.curTrack.filter(function (el) {
                        return el.length;
                    });
                    this.curTrack.sort((ele1, ele2) => Math.random() - Math.random());
                    this.totalAnswers = this.curTrack.length;


                    this.sketch = (p) => {
                        let index = 0;
                        let tracklist = {};


                        p.preload = () => {

                            this.curTrack.map((elem, i) => {
                                tracklist['_' + elem] = {value: elem, sounds: {}};

                                SNR.map((child, i) => {
                                    tracklist['_' + elem].sounds['_' + child] = {
                                        value: child,
                                        index: i,
                                        sound: '/sounds/trippleDigit/sounds/new/' + this.lang + '/' + elem.trim() + '_' + child + '.wav'
                                    }
                                });
                            });

                            this.setState({...this.state, tracklist: tracklist});

                            this.successsound = p.loadSound('/sounds/success.mp3');
                            this.clicksound = p.loadSound('/sounds/click.mp3');

                            songsArray.sort((ele1, ele2) => Math.random() - Math.random());

                            this.curSound = p.loadSound(tracklist['_' + this.curTrack[this.state.curIndex]].sounds['_' + this.state.curSNR].sound);
                            this.samplesound = p.loadSound(tracklist['_' + this.curTrack[this.state.curIndex]].sounds['_' + this.state.curSNR].sound);


                            this.countdownSound = p.loadSound('/sounds/beep.wav?v=' + Date.now());


                        };

                        p.setup = () => {

                            this.allowed = false;


                            if (this.allowed) {
                                this.mic = new p5.AudioIn(() => {
                                    this.allowed = false
                                });

                                this.mic.start();

                                this.maxLevel = 10;
                                this.levelfactor = 200 / (this.maxLevel * 2) / 2;

                                this.micCount = 0;
                                this.micInterval = setInterval(() => {

                                    if (this.mic.getLevel()) {
                                        if (this.mic.getLevel() * 100 >= this.maxLevel) {
                                            this.meterdiv.classList.add('red');
                                            this.meterdiv.classList.remove('yellow');
                                            this.meterdiv.classList.remove('green');
                                            this.state.noiseLevelOK = false;

                                        } else if (this.mic.getLevel() * 100 < this.maxLevel && this.mic.getLevel() * 100 > (this.maxLevel - Math.round(this.maxLevel * 0.3))) {
                                            this.meterdiv.classList.remove('red');
                                            this.meterdiv.classList.add('yellow');
                                            this.meterdiv.classList.remove('green');
                                            this.state.noiseLevelOK = true;


                                        } else {
                                            this.meterdiv.classList.remove('red');
                                            this.meterdiv.classList.remove('yellow');
                                            this.meterdiv.classList.add('green');
                                            this.state.noiseLevelOK = true;
                                        }
                                        this.micCount++;

                                        if (this.micCount >= 10) {
                                            this.setState({...this.state, noiseLevelOK: this.state.noiseLevelOK});
                                            this.micCount = 0;
                                        }
                                        let curMeter = Math.round(((200 * (this.mic.getLevel())) * this.levelfactor));

                                        if (curMeter > 200) {
                                            curMeter = 200;
                                        }

                                        if (curMeter < 0) {
                                            curMeter = 0;
                                        }

                                        document.getElementById('meter').style.strokeDashoffset = 200 - curMeter;

                                    }
                                }, 100);
                            } else {
                                this.micInterval = false;
                            }

                            this.index = index;
                            this.clicksound.setVolume(0.2);
                            analyzer = new p5.Amplitude();
                            analyzer.setInput(this.curSound);

                            this.curSound.onended((e) => {
                                if (document.querySelector('.testMain')) {
                                    document.querySelector('.testMain').classList.add('inputshow');
                                    this.setState({...this.state, disabled: false, countdown: true});
                                }

                                clearTimeout(this.inputNoticeTimeout);
                                this.inputNoticeTimeout = setTimeout(() => {
                                    this.setState({showInputNotice: true})
                                }, 3000)

                            });
                            this.curSound.setVolume(1.0);

                            this.setState({
                                ...this.state,
                                isLoading: false,
                            })
                        };


                        p.draw = () => {
                            // Get the average (root mean square) amplitude

                            if (analyzer.getLevel() > 0) {
                                this.siriWave.setAmplitude(1);
                            } else {
                                this.siriWave.setAmplitude(0.000000001)
                            }
                            if (this.state.tracklist['_' + this.curTrack[this.state.curIndex]].sounds['_' + this.state.curSNR] && this.state.tracklist['_' + this.curTrack[this.state.curIndex]].sounds['_' + this.state.curSNR].sound) {
                                if (this.curSound.isPlaying()) {

                                    this.setState({
                                        ...this.state,
                                        curSound: this.state.tracklist['_' + this.curTrack[this.state.curIndex]].sounds['_' + this.state.curSNR].value,
                                    });
                                } else {

                                    this.index = this.state.tracklist['_' + this.curTrack[this.state.curIndex]].sounds['_' + this.state.curSNR].index;
                                }
                            }
                        };
                    }

                    this.setState({...this.state, sketch: true}, ()=>{
                        new p5(this.sketch);
                    })
                });
        }, 1000)

        auth.checkAccessToken();

        window.removeEventListener("blur", this.onBlur);
        window.addEventListener("blur", this.onBlur);

    }

    render() {
        const {classes, t} = this.props;
        this.boxClass = ["test-content"];
        if (this.state.startTest) {
            this.boxClass.push('start-test');
        }

        if (this.state.finishedTest) {
            this.boxClass.push('finish-test');
        }

        this.boxClass = this.boxClass.join(' ');
        return (
            <div
                className={(this.state.startTest && !this.state.finishedTest) ? 'trippledigittest started' : 'trippledigittest'}>
                <div className={classes.root}>
                    <ElevationScroll {...this.props}>
                        <AppBar color="default">
                            <Toolbar>
                                <Typography variant="h6" className={classes.title}
                                            style={{
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}>{t('threeDigitTest.title')}</Typography>
                                <IconButton data-closetext={t('closeLabel')} className={'right-button close-icon left'}
                                            edge="end" color="primary" aria-label="menu"
                                            onClick={() => this.handleClickOpen()}>
                                    <CloseIcon></CloseIcon>
                                </IconButton>
                            </Toolbar>
                            <div id={'percentage'} className={'percentage-bar'}></div>
                        </AppBar>
                    </ElevationScroll>
                    <Toolbar/>
                    <Box className={this.boxClass}>
                        <Container maxWidth='sm'>
                            <div className={'top'}>
                                <Typography variant="body1" style={{marginBottom: 20}}>
                                    <strong>{t('lingTest.procedure')}</strong><br/>
                                    <ol style={{paddingLeft: 25, marginBottom: 30}}>
                                        <li><Trans i18nKey="threeDigitTest.procedureInfo1"></Trans></li>
                                        <li><Trans i18nKey="threeDigitTest.procedureInfo2"></Trans></li>
                                        <li><Trans i18nKey="threeDigitTest.procedureInfo3"></Trans></li>
                                        <li><Trans i18nKey="threeDigitTest.procedureInfo4"></Trans></li>
                                    </ol>
                                </Typography>

                                <TestMode/>
                                <div style={{textAlign: 'center', paddingBottom: 100, marginTop: -30}}>
                                    <strong style={{fontSize: 12, color: 'black'}}>
                                        <Trans i18nKey="threeDigitTest.copyrightText"></Trans>
                                    </strong>
                                </div>

                                <div id="meter-container" className={this.state.noiselevel}>
                                    <svg viewBox="0 0 207.05 104">

                                        <path className="meter-bg"
                                              d="M101.45-.63A103.63,103.63,0,0,0-.08,102.84H79.55a23.92,23.92,0,0,1,21.9-23.79Z"
                                              transform="translate(0.08 1.16)"/>
                                        <path className="meter-bg"
                                              d="M105.43-.63V79.05a23.91,23.91,0,0,1,21.9,23.79H207A103.63,103.63,0,0,0,105.43-.63Z"
                                              transform="translate(0.08 1.16)"/>
                                        <path id="disallowed" className="meter-points"
                                              d="M182.22,68.3h2.24v2.24h-2.24Zm1.92-9h2.1V57.23h-2.1Zm0,7.47h2.2v-2.2h-2.2ZM186.33,72h-2.28v2.28h2.28Zm-7.85,6h2.31V75.69h-2.31Zm3.7,0h2.31V75.69h-2.31Zm.08-14.93h2.15V60.92h-2.15Zm3.7,0h2.16V60.92H186Zm-1.78-11.2h2v-2h-2ZM182.62,72h-2.28v2.28h2.28ZM184,81.74h2.37V79.37H184Zm-1.6-41.07h1.87V38.79H182.4Zm-9.51,41.07h2.37V79.37h-2.37ZM171.07,78h2.31V75.69h-2.31Zm0-7.46h2.24V68.3H171.1ZM167.36,78h2.31V75.69h-2.31Zm9.28-3.73h2.28V72h-2.28Zm2-18.66h2.06V53.54H178.6Zm1.83,3.73h2.11V57.23h-2.11Zm1.88-3.73h2.06V53.54h-2.06Zm-3.8,14.93h2.24V68.3h-2.24Zm-3.78,14.93h2.39V83.06h-2.39Zm-10.58-6.1h-2.37v2.37h2.37Zm27.26,2.37h2.37V79.37h-2.37ZM159.87,92.93h2.48V90.44h-2.48Zm35.74-17.24H193.3V78h2.31Zm0,7.37h-2.4v2.41h2.4Zm-35.21-3.69h-2.37v2.37h2.37Zm1.87,3.69h-2.4v2.41h2.4ZM160,70.54h2.24V68.3H160Zm-1.79-11.2h2.11V57.23H158.2ZM197.44,72h-2.28v2.28h2.28Zm-4.11-1.45h2.24V68.3h-2.24Zm-5.58,3.73H190V72h-2.28Zm3.71,0h2.28V72h-2.28Zm3.74-7.46h2.2v-2.2h-2.2Zm4.11,8.88H197V78h2.31ZM187.8,66.81H190v-2.2H187.8Zm1.87-3.74h2.15V60.92h-2.15ZM201.15,72h-2.28v2.28h2.28ZM197,70.54h2.23V68.3H197ZM202.57,73v1.3H203Zm-3.66-6.16h1.58c-.27-.74-.55-1.47-.84-2.2h-.74Zm-12.5,20H184V89.2h2.44Zm14.78-7.39h-2.37v2.37h2.37Zm-7.37,7.39h-2.44V89.2h2.44Zm-9.29-3.7h-2.39v2.41h2.39Zm16.7,3.7h-2.44V89.2h2.44Zm-1.83,3.68h-2.49v2.49h2.49Zm-1.88-3.68h-2.44V89.2h2.44Zm-5.58-3.7h-2.39v2.41h2.39Zm-3.75-7.37h-2.3V78h2.3Zm-30-8.88h2.19v-2.2h-2.19Zm31.92,12.56h-2.37v2.37h2.37Zm5.61,11.07h-2.48v2.49h2.48Zm-4.15-31.1h2.11V57.23h-2.11ZM203,75.69H200.7V78H203Zm-13.3-20.08h2.07V53.54h-2.07Zm-3.65-7.48h2v-2h-2Zm-1.83-3.73h1.92V42.48h-1.92Zm3.61,14.94H190V57.23h-2.11Zm5.54,3.73h2.15V60.92h-2.15Zm10.9,16.3h-1.75v2.37h2.27C204.64,81,204.46,80.16,204.28,79.37Zm.79,3.69h-.7v2.41h1.14C205.37,84.66,205.22,83.86,205.07,83.06Zm-8-20H199c-.3-.72-.61-1.44-.93-2.15h-1Zm-22.19-7.46H177V53.54h-2.07ZM173,66.81h2.19v-2.2H173Zm-3.66-7.47h2.1V57.23h-2.1Zm1.87-3.73h2.06V53.54h-2.06Zm-5.58,3.73h2.11V57.23h-2.11Zm-.08,14.93h2.28V72h-2.28Zm2-18.66h2.06V53.54h-2.06Zm-.05,7.46h2.15V60.92h-2.15Zm1.83,3.74h2.2v-2.2h-2.2Zm4.15,16.25H171v2.41h2.4Zm3.66-7.37h-2.31V78h2.31Zm-3.62,14.75H171v2.49h2.48Zm1.84-3.68h-2.45V89.2h2.45Zm7.37-7.39H180.3v2.37h2.37Zm-5.5,11.07h-2.49v2.49h2.49Zm3.7,0h-2.48v2.49h2.48ZM179,79.37H176.6v2.37H179Zm-9.24,3.69h-2.4v2.41h2.4Zm-3.71,0h-2.4v2.41H166Zm0,7.38h-2.48v2.49h2.48ZM163.66,78H166V75.69h-2.31Zm4.19,1.37h-2.37v2.37h2.37ZM171.51,72h-2.28v2.28h2.28Zm-50-66.37V7h1.4V5.62Zm1.67,27.57H125V31.42h-1.77Zm3.7,0h1.77V31.42h-1.77ZM123.34,9.31v1.44h1.44V9.31ZM121.25,44.4h1.92V42.48h-1.92ZM127,16.68v1.56h1.55V16.68Zm-9.4,20.25h1.83V35.1h-1.83Zm-1.92,11.2h2v-2h-2Zm3.75-7.46h1.87V38.79h-1.87Zm.16-24v1.56h1.55V16.68ZM117.76,13v1.5h1.49V13Zm20.4-3.69v1.44h1.44V9.31ZM138,33.19h1.78V31.42H138Zm-.05,7.48h1.88V38.79h-1.88Zm3.87-22.43h1.55V16.68h-1.55Zm.06-8.93v1.44h1.43V9.31ZM128.7,36.93h1.84V35.1H128.7Zm13-3.74h1.77V31.42H141.7ZM126.79,48.13h2v-2h-2Zm5.62-11.2h1.83V35.1h-1.83ZM132.58,13v1.5h1.49V13Zm-3.66-7.38V7h1.4V5.62ZM106.38,51.87h2v-2h-2Zm2-26.15h1.67V24h-1.67ZM110.29,22h1.61V20.36h-1.61ZM108.52,9.31v1.44H110V9.31Zm-.16,23.88h1.77V31.42h-1.77ZM106.43,44.4h1.92V42.48h-1.92Zm99.67,58.44H207c0-.44,0-.89,0-1.33h-.85ZM106.53,29.45h1.72V27.73h-1.72Zm0,7.48h1.83V35.1h-1.83Zm9.4-20.25v1.56h1.55V16.68ZM106.64,13v1.5h1.5V13Zm7.3,16.45h1.72V27.73h-1.72ZM110.4,5.62V7h1.39V5.62Zm3.49,31.31h1.83V35.1h-1.83Zm0,7.47h1.92V42.48h-1.92Zm1.93-11.21h1.77V31.42h-1.77ZM114.1,5.62V7h1.4V5.62Zm-2,20.1h1.67V24h-1.67ZM112,48.13h2v-2h-2Zm-1.73-18.68H112V27.73h-1.71Zm1.93-12.77v1.56h1.56V16.68Zm42.2,65.06h2.37V79.37h-2.37Zm17-50.32v1.77h1.77V31.42Zm-7.41,1.77h1.77V31.42h-1.77Zm7.66,53.57h-2.44V89.2h2.44ZM175,40.67h1.87V38.79H175Zm0-9.25v1.77h1.77V31.42Zm-7.41,0v1.77h1.77V31.42ZM164,24v1.68h1.67V24Zm3.6,16.63h1.87V38.79h-1.87Zm-1.87,3.73h1.91V42.48h-1.91Zm.1-16.67v1.72h1.71V27.73Zm5.47,12.94h1.88V38.79h-1.88Zm-12.72,35h-2.31V78h2.31Zm-6-5.15h2.24V68.3h-2.24Zm0,7.46h2.31V75.69h-2.31Zm0,7.47h2.4V83.06h-2.4Zm0,7.46h2.48V90.44h-2.48Zm1.95-18.66h2.28V72h-2.28Zm-.08,14.93h2.44V86.76h-2.44Zm12.95,3.73h2.48V90.44h-2.48Zm-11.12,0h2.49V90.44h-2.49Zm-1.71-26.12h2.2v-2.2h-2.2Zm7.6-29.88h1.83V35.1h-1.83Zm0-9.2v1.72h1.72V27.73Zm-13,12.94h1.87V38.79h-1.87Zm.1-16.63v1.68h1.67V24Zm-3.81,16.63h1.88V38.79h-1.88Zm3.76-7.48h1.77V31.42h-1.77Zm-2,26.15h2.1V57.23h-2.1Zm-1.52-50v1.44H147V9.31ZM143.48,44.4h1.92V42.48h-1.92Zm.1-16.67v1.72h1.72V27.73Zm1.88-2h1.67V24h-1.67ZM147.39,13v1.5h1.5V13ZM151,29.45h1.71V27.73H151Zm1.77,11.22h1.88V38.79h-1.88Zm5.49,11.2h2v-2h-2ZM141.6,48.13h2v-2h-2Zm16.8-20.4v1.72h1.71V27.73ZM150.89,44.4h1.92V42.48h-1.92Zm.15-24V22h1.61V20.36Zm1.88-3.68v1.56h1.56V16.68Zm-.11,16.51h1.77V31.42h-1.77Zm44.76,60.94H195v2.54h2.54Zm-40.75,0h-2.54v2.54h2.54Zm-3.88-29.52h-2.19v2.2h2.19ZM155,97.82h-2.58v2.59H155Zm7.41,0h-2.58v2.59h2.58Zm-1.92-11.06H158V89.2h2.45ZM158.7,97.82h-2.59v2.59h2.59Zm-14.82,0h-2.59v2.59h2.59Zm1.83-3.69h-2.54v2.54h2.54Zm5.58,3.69H148.7v2.59h2.59Zm-1.88-3.69h-2.54v2.54h2.54Zm-1.83,3.69H145v2.59h2.58Zm29.64,0h-2.59v2.59h2.59Zm-1.87-3.69H172.8v2.54h2.55Zm5.58,3.69h-2.59v2.59h2.59Zm-1.88-3.69h-2.54v2.54h2.54Zm-5.54,3.69h-2.58v2.59h2.58Zm-7.4,0h-2.59v2.59h2.59Zm-1.88-3.69h-2.54v2.54h2.54Zm3.66-7.37h-2.44V89.2h2.44Zm3.75,7.37H169.1v2.54h2.54Zm-1.83,3.69h-2.59v2.59h2.59ZM124.86,59.34H127V57.23h-2.11ZM142,94.13h-2.55v2.54H142Zm-33.8-38.52h2.07V53.54h-2.07Zm9.34-11.21h1.91V42.48h-1.91Zm65.2,49.73h-2.54v2.54h2.54ZM110,59.34h2.11V57.23H110Zm11.16-7.47h2v-2h-2ZM125,36.93h1.83V35.1H125ZM127.06,72h-2.29v2.28h2.29Zm-4.15,6h2.31V75.69h-2.31Zm1.91-13.39v2.2H127v-2.2Zm-3.48-18.44h-2v2h2Zm-15.91,9.44h1.14V53.54h-1.14Zm27.33,42.21h-2.58v2.59h2.58Zm3.71,0h-2.59v2.59h2.59ZM124.73,81.74h2.37V79.37h-2.37ZM138.3,94.13h-2.54v2.54h2.54Zm-3.76-7.37H132.1V89.2h2.44Zm-7.35,7.37h-1.51a22.12,22.12,0,0,1,.82,2.54h.69Zm-3.76-7.37h-2.36A24.15,24.15,0,0,1,123,89.2h.42Zm7.46,7.37h-2.54v2.54h2.54Zm-2-18.44h-2.31V78h2.31Zm11.25,22.13h-2.58v2.59h2.58Zm13,3.69h-2.63v1.33h2.63Zm-3.7,0h-2.63v1.33h2.63Zm11.11,0h-2.63v1.33h2.63Zm-14.82,0h-2.63v1.33h2.63Zm11.12,0h-2.63v1.33h2.63Zm-25.94,1.33v-1.33h-2.62v1.33Zm3.71-1.33H132v1.33h2.63Zm29.64,0h-2.63v1.33h2.63Zm-25.94,0h-2.63v1.33h2.63Zm3.71,0h-2.63v1.33h2.63Zm-13-3.69h-2.28a22.21,22.21,0,0,1,.43,2.59h1.85Zm61.15,3.69h-2.63v1.33h2.63Zm3.7,0h-2.63v1.33h2.63Zm3.71,0H195v1.33h2.63Zm7.41,0H202.4v1.33H205Zm-37.05,0h-2.63v1.33H168Zm18.52,0h-2.63v1.33h2.63Zm-14.82,0h-2.63v1.33h2.63Zm11.12,0h-2.63v1.33h2.63Zm-7.41,0h-2.63v1.33h2.63Zm3.7,0h-2.63v1.33h2.63Zm14.78-7.38h-2.54v2.54h2.54Zm1.87,3.69h-2.58v2.59h2.58Zm3.71,0h-2.59v2.59h2.59Zm1.83-3.69h-2.54v2.54h2.54Zm3.7,0h-2.54v2.54H205Zm-20.4-3.69h-2.49v2.49h2.49Zm18.48-7.38h-2.4v2.41h2.4Zm-16.6,11.07h-2.54v2.54h2.54Zm1.82-3.69H185.8v2.49h2.48Zm1.88,3.69h-2.54v2.54h2.54ZM192,90.44H189.5v2.49H192ZM106.48,40.67V38.79h-1v1.88Zm72.27-7.48H180l-1.2-1.3Zm1.82,1.91v1.83h1.83V36l-.76-.87Zm26.29,63a1.85,1.85,0,0,1,0-.23h-2.58v2.59h2.59ZM106.43,33.19V31.42h-1v1.77Zm-1-23.88v1.44h.83V9.31ZM154.8,14.5h1.5v-.62L154.8,13Zm51.34,79.63v2.54h.64c-.05-.85-.11-1.7-.18-2.54ZM193.42,55.61h2.06v-.12c-.34-.65-.68-1.3-1-2h-1Zm-3.66-7.48h1.53c-.41-.66-.84-1.31-1.26-2h-.27Zm1.83,3.74h1.94c-.39-.68-.78-1.35-1.18-2h-.76Zm-61.32,33.6h2.4V83.06h-2.4Zm9.85,5h-2.48v2.49h2.48Zm-4.28-8.7h2.37V79.37h-2.37ZM137.73,78H140V75.69h-2.31Zm7.89,1.37h-2.37v2.37h2.37Zm-1.84,3.69h-2.39v2.41h2.39Zm-1.86-3.69h-2.37v2.37h2.37ZM141.43,78h2.31V75.69h-2.31Zm.12-22.39h2.07V53.54h-2.07Zm3.9-5.76h-2v2h2Zm-5.86,24.42h2.28V72h-2.28Zm-1.83-3.73H140V68.3h-2.24Zm-3.66-7.47h2.15V60.92H134.1ZM134,78h2.31V75.69H134Zm4.23,8.76h-2.44V89.2h2.44Zm-2.09-40.59h-2v2h2ZM134,85.47h2.4V83.06H134Zm9.36-18.66h2.19v-2.2h-2.19Zm-3.62-14.94h2v-2h-2Zm7.73,23.82h-2.31V78h2.31Zm-7.77-16.35h2.11V57.23h-2.11Zm0,7.47h2.19v-2.2h-2.19Zm.44,16.25h-2.4v2.41h2.4Zm33.08-46.13H175V35.1h-1.83Zm0,7.47H175V42.48h-1.91Zm-3.76,7.47h2v-2h-2Zm-1.82-3.74h2v-2h-2Zm-1.88,3.74h2v-2h-2ZM175,48.13h2v-2h-2Zm5.52,3.74h2v-2h-2Zm-3.61-14.94h1.83V35.1h-1.83Zm1.79,11.2h2v-2h-2Zm0-7.46h1.88V38.79h-1.88Zm-18.52,0h1.88V38.79h-1.88Zm1.65,33.6h2.28V72h-2.28Zm-9.2-11.2h2.15V60.92h-2.15ZM154.74,22h1.62V20.36h-1.62ZM149,48.13h2v-2h-2Zm3.66,7.48h2.06V53.54h-2.06Zm.23,1.62h-2.11v2.11h2.11Zm7.18-1.62h2.06V53.54h-2.06Zm-3.75,7.46h2.15V60.92h-2.15ZM138,49.85h-2v2h2Zm18.33,5.76h2.07V53.54h-2.07Zm-50.94,7.46h1.18V60.92h-1.18ZM111.79,78h2.31V75.69h-2.31Zm1.91-11.19h2.2v-2.2h-2.2Zm1.88-3.74h2.15V60.92h-2.15Zm0-7.46h2.06V53.54h-2.06Zm-1.87,3.73h2.1V57.23h-2.1ZM115.94,72h-2.28v2.28h2.28Zm11.2,14.77h-2.45V89.2h2.45Zm-7.9-16.22h2.24V68.3h-2.24Zm0,7.46h2.31V75.69H119.2Zm-1.84-3.73h2.29V72h-2.29Zm-11-14.93h2.1V57.23h-2.1Zm5.49,11.2h2.24V68.3h-2.24Zm-4.06,8.83c.27,0,.54.12.81.18v-.18Zm13.79,3.69h-2.4v1.83c.21.19.42.38.62.58h1.78Zm1.83-3.69H121v2.37h2.36Zm1.87,3.69h-2.4v2.41h2.4Zm-7.41,0h-1.09c.37.25.74.49,1.09.76ZM110,74.27h2.28V72H110Zm-1.79-11.2h2.15V60.92h-2.15Zm17,29.86h.15V90.44h-1.46A25.66,25.66,0,0,1,125.15,92.93Zm-18.9-18.66h2.28V72h-2.28ZM137.9,48.13h2v-2h-2Zm-5.19,44.8V90.44h-2.48v2.49Zm12.55-37.32h2.06V53.54h-2.06Zm5.93,27.45H148.8v2.41h2.39Zm-5.88-34.93h2v-2h-2Zm-5.49-11.2h1.83V35.1h-1.83ZM142,86.76h-2.44V89.2H142Zm7.38-7.39H147v2.37h2.37Zm-3.67,7.39h-2.44V89.2h2.44Zm-1.83,3.68h-2.49v2.49h2.49Zm3.66-7.38h-2.4v2.41h2.4ZM148.84,78h2.31V75.69h-2.31ZM136.07,44.4H138V42.48h-1.92Zm-3.84,22.41h2.19v-2.2h-2.19Zm-1.48-56.06h1.44V9.31h-1.44Zm-2.31,71h2.36V79.37h-2.36Zm53.92-33.61h2v-2h-2Zm-48.12-7.46h1.87V38.79h-1.87Zm-1.88,3.73h1.92V42.48h-1.92Zm-.05,7.47h2v-2h-2Zm0,7.47h2.11V57.23h-2.11Z"
                                              transform="translate(0.08 1.16)"/>
                                        <path id="allowed" className="meter-points"
                                              d="M41.85,74.27H39.57V72h2.28Zm24-13.35H63.71v2.15h2.15ZM37.7,78H40V75.69H37.7Zm7.85-6H43.27v2.28h2.28Zm19.91,9.75h2.37V79.37H65.46ZM41.41,78h2.31V75.69H41.41Zm4.22,8.76H43.19V89.2h2.44ZM72.91,74.27h2.28V72H72.91ZM71,78h2.31V75.69H71Zm-1.88,3.74h2.37V79.37H69.16ZM52.92,64.61H50.73v2.2h2.19ZM41.49,63.07h2.15V60.92H41.49Zm9.56-2.15H48.9v2.15h2.15ZM49.26,72H47v2.28h2.28ZM73,66.81h2.2v-2.2H73ZM49.17,57.23H47.06v2.11h2.11ZM47,66.81h2.19v-2.2H47ZM43.76,83.06h-2.4v2.41h2.4Zm5,9.87h2.48V90.44H48.73ZM47.42,75.69H45.11V78h2.31ZM45.6,79.37H43.23v2.37H45.6Zm27.27,2.37h2.36V79.37H72.87ZM23,63.07h2.15V60.92H23ZM22.88,78h2.31V75.69H22.88Zm1.91-11.19H27v-2.2h-2.2ZM21,74.27h2.29V72H21Zm4.12-6H22.92v2.24h2.24Zm-6,9.7h2.31V75.69H19.18Zm4.19,1.37H21v2.37h2.37Zm-4.24,6.1h2.4V83.06h-2.4Zm2.05-33.6h2v-2h-2Zm-.05,7.47h2.11V57.23H21.13ZM27,72H24.75v2.28H27ZM74.87,55.61h2.06V53.54H74.87ZM73,59.34h2.1V57.23H73ZM25.24,83.06h-2.4v2.41h2.4ZM54.79,68.3H52.56v2.24h2.23Zm22.27,7.39H74.75V78h2.31ZM74.83,63.07H77V60.92H74.83Zm.09-16.9v2h2v-2Zm-46,29.52H26.59V78H28.9ZM65.82,53.54H63.76v2.07h2.06ZM27.11,86.76H24.67V89.2h2.44ZM61.88,59.34H64V57.23H61.88ZM39.61,66.81h2.2v-2.2h-2.2Zm-9.28,3.73h2.24V68.3H30.33Zm6,5.15H34V78h2.31Zm-6.06,9.78h2.4V83.06h-2.4Zm2-26.13h2.1V57.23h-2.1Zm1.87-3.73h2.06V53.54H34.12Zm7.41,0h2.06V53.54H41.53Zm-1.87,3.73h2.1V57.23h-2.1Zm-5.18,20H32.12v2.37h2.36Zm3.34-23.76h2.07V53.54H37.82Zm-2,18.66h2.28V72H35.86Zm1.92-11.2h2.15V60.92H37.78Zm18.52,0h2.15V60.92H56.3ZM28.5,66.81h2.19v-2.2H28.5Zm9.72,20H35.78V89.2h2.44Zm1.83-3.7H37.66v2.41h2.39Zm3.75,7.38H41.32v2.49H43.8Zm-1.87-3.68H39.49V89.2h2.44Zm-5.58-3.7H34v2.41h2.4Zm-5.57-3.69H28.41v2.37h2.37Zm-2.33-5.1h2.29V72H28.45Zm6.07,12.49H32.08V89.2h2.44Zm-1.83,3.68H30.21v2.49h2.48ZM34.44,72H32.16v2.28h2.28Zm25.93,0H58.09v2.28h2.28Zm-1.84,3.7H56.22V78h2.31Zm5.59,3.68H61.75v2.37h2.37ZM56.67,72H54.39v2.28h2.28Zm5.49-11.07H60v2.15h2.15ZM61.8,74.27h2.28V72H61.8Zm-5.54-3.73H58.5V68.3H56.26Zm-1.83-3.73h2.19v-2.2H54.43Zm.4,8.88H52.52V78h2.31Zm-4.15-1.42H53V72H50.68Zm5.67-18.66h2.06V53.54H56.35Zm-7.41,0H51V53.54H48.94ZM49,48.13h2v-2H49Zm11.06,7.48h2.07V53.54H60.05ZM47.11,51.87h2v-2h-2Zm3.66,7.47h2.11V57.23H50.77Zm-5.54-3.73H47.3V53.54H45.23Zm-1.87,3.73h2.11V57.23H43.36Zm14.86-7.47h2v-2h-2ZM52.6,63.07h2.15V60.92H52.6Zm1.87-3.73h2.11V57.23H54.47ZM67.29,85.47h2.4V83.06h-2.4Zm-8.92-56h1.72V27.73H58.37ZM58.48,13v1.5H60V13Zm1.77,11v1.68h1.67V24ZM58.32,36.93h1.83V35.1H58.32Zm1.78,11.2h2v-2h-2ZM58.42,22H60V20.36H58.42Zm-3.75,7.47h1.71V27.73H54.67ZM56.54,24v1.68h1.67V24ZM54.78,13v1.5h1.49V13ZM52.9,16.68v1.56h1.55V16.68Zm3.5,31.45h2v-2h-2ZM54.57,44.4h1.92V42.48H54.57ZM71.42,16.68v1.56H73V16.68Zm-.06,9H73V24H71.36Zm0,7.47h1.77V31.42H71.31Zm1.88-3.74h1.72V27.73H73.19ZM71.26,40.67h1.87V38.79H71.26ZM69.54,20.36V22h1.61V20.36ZM63.9,33.19h1.78V31.42H63.9Zm.17-23.88v1.44h1.44V9.31Zm-.26,38.82h2v-2h-2Zm5.58-3.73H71.3V42.48H69.39ZM28.68,35.1v1.83h1.83V35.1Zm24.06,5.57h1.87V38.79H52.74Zm-14.82,0h1.87V38.79H37.92Zm3.75-7.48h1.78V31.42H41.67Zm-1.82-5.46v1.72h1.72V27.73ZM39.7,51.87h2v-2h-2ZM38,31.42v1.77h1.77V31.42Zm-3.75,9.25h1.87V38.79H34.22Zm42.22,62.17h2.63v-1.33H76.44Zm-47.85-51h2v-2h-2ZM73.3,13v1.5h1.5V13Zm-39,18.42v1.77H36V31.42Zm14.81,0v1.77h1.78V31.42Zm0,9.25h1.88V38.79H49Zm2-20.31V22h1.61V20.36Zm-3.76,7.37v1.72H49V27.73Zm3.65,9.2h1.83V35.1H50.91Zm-9.33,11.2h2v-2h-2Zm5.58-3.73h1.92V42.48H47.16ZM41.73,24v1.68H43.4V24ZM43.4,51.87h2v-2h-2Zm.16-24.14v1.72h1.71V27.73ZM97.19,40.67h1.88V38.79H97.19ZM93.65,18.24H95.2V16.68H93.65Zm.06-8.93v1.44h1.43V9.31Zm-2,27.62h1.83V35.1H91.66Zm1.93-11.21h1.67V24H93.59Zm-.1,15h1.87V38.79H93.49ZM91.72,29.45h1.71V27.73H91.72ZM89.88,24v1.68h1.68V24Zm2-11v1.5h1.49V13Zm-2,20.19h1.78V31.42H89.83Zm5.59-3.74h1.71V27.73H95.42Zm1.73,18.68h2v-2h-2ZM99.28,5.62V7h1.4V5.62ZM88,27.73v1.72h1.72V27.73ZM95.53,13v1.5H97V13ZM59.84,92.93h2.49V90.44H59.84Zm4.32-6.17H61.72V89.2h2.44Zm24-3.7H85.82v2.41H87.1c.36-.34.74-.66,1.11-1ZM46.93,81.74H49.3V79.37H46.93ZM95.36,36.93h1.83V35.1H95.36Zm3.71,0h1.83V35.1H99.07ZM97.35,16.68v1.56h1.56V16.68ZM82.43,33.19H84.2V31.42H82.43ZM76.8,44.4h1.91V42.48H76.8Zm2-18.68h1.67V24H78.77ZM77.06,5.62V7h1.39V5.62Zm1.66,27.57h1.77V31.42H78.72Zm.17-23.88v1.44h1.44V9.31ZM77,22h1.61V20.36H77Zm3.59,15h1.84V35.1H80.54ZM75.18,9.31v1.44h1.44V9.31ZM87.86,51.87h2v-2h-2ZM75,40.67h1.87V38.79H75Zm.1-15h1.67V24H75.07Zm9.18,11.21h1.83V35.1H84.25Zm.06-7.48H86V27.73H84.31Zm0-9.09V22H86V20.36Zm1.72,20.31H88V38.79H86.08ZM80.6,27.73v1.72h1.72V27.73Zm5.53,3.69v1.77H87.9V31.42Zm-3.65-5.7h1.67V24H82.48Zm-2,18.68h1.92V42.48H80.5Zm-7.37-7.47H75V35.1H73.13ZM82.59,9.31v1.44H84V9.31ZM19.75,94.13H17.21v2.54h2.54Zm13,3.69H30.15v2.59h2.59Zm5.54-3.69H35.73v2.54h2.55Zm-3.71,0H32v2.54h2.54Zm24.1,3.69H56.09v2.59h2.58Zm-22.22,0H33.86v2.59h2.59Zm-5.58-3.69H28.32v2.54h2.55Zm-9.29-3.69H19.09v2.49h2.49Zm5.58,3.69H24.62v2.54h2.54Zm-9.24,3.69H15.34v2.59h2.58Zm5.49-11.06H21V89.2h2.45Zm1.87,3.68H22.8v2.49h2.48Zm26,7.38H48.68v2.59h2.58ZM53,86.76H50.6V89.2H53Zm-37,7.37H13.51v2.54h2.54ZM55,97.82H52.38v2.59H55Zm-5.58-3.69H46.85v2.54h2.54Zm7.41,0H54.26v2.54H56.8ZM42,94.13H39.44v2.54H42Zm5.58,3.69H45v2.59h2.59ZM40.1,90.44H37.61v2.49H40.1Zm3.75,7.38H41.27v2.59h2.58Zm1.83-3.69H43.14v2.54h2.54ZM29,97.82H26.45v2.59H29ZM17.87,90.44H15.39v2.49h2.48ZM16,86.76H13.56V89.2H16Zm-1.88-3.7H11.73v2.41h2.39Zm1.31,2.41h2.4V83.06h-2.4Zm-1.79-11.2h2.28V72H13.64ZM12.21,72H9.93v2.28h2.28ZM10.42,83.06H8v2.41h2.4Zm-1.83,3.7H6.15V89.2H8.59ZM11.77,78h2.31V75.69H11.77Zm2-18.66h2.11V57.23H13.72ZM10,66.81h2.19v-2.2H10ZM8.64,94.13H6.1v2.54H8.64Zm-3.71,0H2.39v2.54H4.93Zm1.88,3.69H4.22v2.59H6.81Zm5.53-3.69H9.8v2.54h2.54Zm-.53-23.59H14V68.3H11.81Zm-1.3,27.28H7.93v2.59h2.58Zm-7.41,0H.52v2.59H3.1Zm11.12,0H11.63v2.59h2.59ZM10,58.27v1.07h2.1V57.23H10.53ZM1.18,86.76h0C1,87.57.93,88.38.82,89.2h.36ZM100.9,40.67h.55V38.79h-.55ZM8.68,101.51H6.05v1.33H8.68Zm-7.41,0H-.07c0,.44,0,.89,0,1.33H1.27Zm11.12,0H9.76v1.33h2.63Zm7.41,0H17.17v1.33H19.8ZM60.45,86.76H58V89.2h2.44ZM30.91,101.51H28.28v1.33h2.63ZM28.63,33.19V31.42h0c-.56.58-1.11,1.17-1.66,1.77ZM25,36.93h1.84V35.1H25.24l-.27.31Zm-5.53,5.55h0q-.69.95-1.35,1.92h1.39ZM11.89,55.61H14V53.54H12.44l-.55,1Zm9.38-14.94V40c-.18.23-.35.47-.53.71Zm39.28,60.84H57.92v1.33h2.63ZM36,25.72V24.4c-.51.44-1,.87-1.5,1.32Zm32,75.79H65.33v1.33H68Zm-3.71,0H61.62v1.33h2.63Zm-29.64,0H32v1.33h2.62Zm40.75,0H72.74v1.33h2.62Zm4.74-3.69H78.31v2.59h1.37A24.52,24.52,0,0,1,80.1,97.82Zm-41.78,3.69H35.69v1.33h2.63Zm3.7,0H39.39v1.33H42Zm11.12,0H50.51v1.33h2.63Zm3.7,0H54.21v1.33h2.63Zm-40.75,0H13.46v1.33h2.63Zm57.4-3.69H70.9v2.59h2.59Zm-3.7,0H67.2v2.59h2.59Zm1.83-3.69H69.07v2.54h2.55Zm5.58,3.69H74.61v2.59H77.2Zm-1.88-3.69H72.78v2.54h2.54Zm3.71,0H76.48v2.54H79Zm-11.12,0H65.37v2.54h2.54Zm-3.7,0H61.67v2.54h2.54Zm-1.83,3.69H59.79v2.59h2.59Zm3.7,0H63.5v2.59h2.58ZM65.94,7h1.4V5.85l-1.4.53ZM80.85,90.44H78.37v2.49h2.48ZM39.9,22h1.62V20.36H41l-1.08.83ZM56.66,10.75H58.1V9.82l-1.44.72Zm44.34,15h.45V24H101ZM51.07,14.5h1.5V13h-.46l-1,.59Zm50,3.74h.39V16.68h-.39Zm-.11,15h.5V31.42H101Zm-17,53.57v2.35a22.5,22.5,0,0,1,1.88-2.35ZM82.07,92.2c.3-.6.63-1.18,1-1.76h-1ZM6.76,90.44H4.27v2.49H6.76ZM78.45,78h2.31V75.69H78.45Zm7.49-14.93h2.15V60.92H85.94Zm-1.83-3.73h2.11V57.23H84.11Zm-1.92,11.2h2.24V68.3H82.19Zm5.63-11.2h2.1V57.23h-2.1Zm-5.58,3.73h2.15V60.92H82.24Zm-1.92,11.2H82.6V72H80.32Zm11.07,7.47h.93c.47-.25,1-.47,1.44-.69V79.37H91.39Zm4.19-6H93.27V78h2.31Zm-4.1-8.88h2.19v-2.2H91.48Zm0-7.47h2.11V57.23H91.52Zm-1.83-3.73h2.06V53.54H89.69Zm5.4,23.76v1.12a24.1,24.1,0,0,1,2.37-.74v-.38ZM84.51,83.06h-2.4v2.41h2.4Zm5.61,0h-.6v.41ZM86.3,72H84v2.28H86.3Zm14.38,6h.77V75.69h-.77ZM97,70.54h2.24V68.3H97ZM80.27,81.74h2.37V79.37H80.27Zm-32.76,8.7H45v2.49h2.49Zm37-14.75H82.16V78h2.31Zm-3.66,7.37h-2.4v2.41h2.4Zm1.87,3.7H80.24V89.2h2.44Zm-13,3.68H67.25v2.49h2.48ZM60.42,79.37H58.05v2.37h2.37Zm-1.84,3.69h-2.4v2.41h2.4Zm9.28,3.7H65.42V89.2h2.44Zm-5.58-3.7H59.89v2.41h2.39Zm-3.66,7.38H56.14v2.49h2.48Zm7.41,0H63.55v2.49H66ZM51.09,68.3H48.85v2.24h2.24Zm5.62,11.07H54.34v2.37h2.37Zm-3.7,0H50.64v2.37H53Zm1.86,3.69H52.48v2.41h2.39Zm22.23,0H74.7v2.41h2.4Zm1.84-3.69H76.57v2.37h2.37ZM91.8,60.92H89.65v2.15H91.8Zm-4,5.89H90v-2.2h-2.2ZM85.86,78h2.31V75.69H85.86Zm3.71,0h2.31V75.69H89.57Zm9.23,1.37v.07l.32-.07ZM71.57,86.76H69.12V89.2h2.45Zm18.48-7.39H87.68v2.37h2.37ZM4.88,86.76H2.44V89.2H4.88Zm70.39,0H72.83V89.2h2.44Zm-1.87-3.7H71v2.41h2.4ZM23.06,48.13h2v-2h-2Zm1.78,11.21h2.1V57.23h-2.1Zm1.83,3.73h2.15V60.92H26.67ZM21.23,44.4h1.91V42.48H21.23Zm-1.88,3.73h2v-2h-2Zm16.7-3.73H38V42.48H36.05ZM30.56,33.19h1.77V31.42H30.56ZM32.34,44.4h1.92V42.48H32.34Zm0-7.47h1.84V35.1H32.38Zm-.09,14.94h2v-2h-2ZM23.1,40.67H25V38.79H23.1Zm-16.43,35H4.36V78H6.67ZM8.06,78h2.31V75.69H8.06ZM6.63,68.3H5.85c-.26.74-.52,1.49-.77,2.24H6.63ZM4.85,81.74V79.37H2.61c0,.18-.09.36-.13.54v1.83Zm5.44-20.82H8.79l-.65,1.5v.65h2.15Zm-3.9,5.89H8.46v-2.2H7.24C7,65.34,6.67,66.07,6.39,66.81Zm12.87-3.74h2.15V60.92H19.26Zm-1.88,3.74h2.2v-2.2h-2.2ZM17.3,81.74h2.37V79.37H17.3Zm2-26.13h2.07V53.54H19.3Zm26-14.94H47.2V38.79H45.33ZM86,48.13h2v-2H86Zm-13-3.73H75V42.48H73.09Zm11.06,7.47h2v-2h-2Zm-5.62,11.2h2.15V60.92H78.53ZM76.7,59.34h2.11V57.23H76.7Zm5.58-3.73h2.06V53.54H82.28Zm16.65,3.73H101V57.23H98.93Zm-3.75,7.47h2.19v-2.2H95.18ZM91.61,44.4h1.92V42.48H91.61Zm0,7.47h2v-2h-2ZM36.09,36.93h1.83V35.1H36.09ZM65.68,44.4H67.6V42.48H65.68Zm-.05,7.47h2v-2h-2Zm3.66,7.47H71.4V57.23H69.29ZM50.86,44.4h1.92V42.48H50.86Zm49.9,18.67h.69V60.92h-.69ZM62,44.4H63.9V42.48H62Zm3.61,14.94h2.1V57.23h-2.1ZM69.2,74.27h2.29V72H69.2ZM67.34,78h2.31V75.69H67.34ZM65.5,74.27h2.28V72H65.5Z"
                                              transform="translate(0.08 1.16)"/>
                                        <path id="meter" d="M39.73,102.84a63.71,63.71,0,0,1,127.42,0"
                                              transform="translate(0.08 1.16)"/>
                                        <rect fill="white" x="101.54" width="3.98" height="86.08"/>
                                    </svg>

                                </div>
                                <div className={'checkWrap'}>
                                    <MedelPaper title={t('lingTest.noiseLevelOkMessage', {level: this.state.level})}
                                                active={this.state.noiseLevelOK}
                                                link={''}/>
                                </div>
                            </div>
                            <div className={'testMain'}>
                                <div id="siri-container-2"></div>
                                <div className={'count-down'}>
                                    <svg className="svg-donut" width="206px" height="206px">
                                        <g stroke="none" fill="none">
                                            <circle className="donut-bg"
                                                    transform="translate(103.000000, 103.000000) scale(1, -1) translate(-103.000000, -103.000000) "
                                                    cx="103" cy="103" r="100"></circle>
                                            <circle id="countdownbig" className="donut"
                                                    transform="translate(103.000000, 103.000000) scale(1, -1) translate(-103.000000, -103.000000) "
                                                    cx="103" cy="103" r="100"></circle>
                                        </g>
                                    </svg>
                                    <div id="countdownbignumber" className={'number'}>5</div>
                                </div>
                                <div className={'input-field'}>
                                    {this.state.input}
                                </div>
                            </div>
                            <div className={'hideme'}>
                            </div>


                            <div className={this.state.isLoading ? 'bottom' : 'bottom loaded'}>
                                <CircularProgress className={classes.progress}/>
                                <Button variant="contained" color="primary" disabled={!this.state.noiseLevelOK}
                                        onClick={() => {

                                            this.setState({
                                                ...this.state,
                                                startTest: parseInt(Date.now() / 1000),
                                                countdown: true
                                            }, () => {
                                                document.querySelector('.testMain').classList.add('countdown');
                                                document.querySelector('.testMain').classList.add('first');

                                                this.startCountdown(() => {
                                                    this.setState({...this.state, countdown: false});

                                                    document.querySelector('.testMain').classList.remove('countdown');
                                                    document.querySelector('.testMain').classList.remove('first');

                                                    if (this.samplesound.isPlaying()) {
                                                        this.samplesound.stop();
                                                    }
                                                    this.curSound.pan(localStorage.getItem('med-curEar') === 'left' ? -1.0 : 1.0);

                                                    this.curSound.setVolume(parseInt(localStorage.getItem(this.user.sub + '-medel-volume' + ('_' + localStorage.getItem('med-curEar')))) / 100);
                                                    this.curSound.play();
                                                    if (this.mic) {
                                                        clearInterval(this.micInterval);
                                                        this.mic.stop();
                                                    }
                                                })
                                            });

                                        }}>
                                    Start
                                </Button>
                            </div>


                            <div className={'testKeyboard numbers new'}>
                                <div className={'inputNotice' + (this.state.showInputNotice ? ' show' : '')}>
                                    <div><img src={'/img/avatar.png'}/></div>
                                    <div>{t('threeDigitTest.inputText')}</div>
                                </div>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(1)}>1</Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(2)}>2</Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(3)}>3</Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(4)}>4</Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(5)}>5</Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(6)}>6</Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(7)}>7</Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(8)}>8</Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(9)}>9</Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick('back')}>&nbsp;
                                    <svg width="59px" height="30px" viewBox="0 0 59 30">
                                        <g id="Screendesign-APP" stroke="none" fill="none">
                                            <g id="Tripple-Digit-Hörtest-2"
                                               transform="translate(-34.000000, -617.000000)">
                                                <g id="Delete" transform="translate(34.000000, 617.000000)">
                                                    <path
                                                        d="M15.9079483,0.5 L0.723976181,15 L15.9079483,29.5 L58.5,29.5 L58.5,0.5 L15.9079483,0.5 Z"
                                                        id="Rectangle" stroke="#000000"></path>
                                                    <g id="schließen-Icon" transform="translate(28.000000, 8.000000)"
                                                       fill="#000000">
                                                        <path
                                                            d="M6.99398587,5.9333257 L12.4576417,0.469669914 C12.7505349,0.176776695 13.2254086,0.176776695 13.5183018,0.469669914 C13.811195,0.762563133 13.811195,1.23743687 13.5183018,1.53033009 L8.05464604,6.99398587 L13.5183018,12.4576417 C13.811195,12.7505349 13.811195,13.2254086 13.5183018,13.5183018 C13.2254086,13.811195 12.7505349,13.811195 12.4576417,13.5183018 L6.99398587,8.05464604 L1.53033009,13.5183018 C1.23743687,13.811195 0.762563133,13.811195 0.469669914,13.5183018 C0.176776695,13.2254086 0.176776695,12.7505349 0.469669914,12.4576417 L5.9333257,6.99398587 L0.469669914,1.53033009 C0.176776695,1.23743687 0.176776695,0.762563133 0.469669914,0.469669914 C0.762563133,0.176776695 1.23743687,0.176776695 1.53033009,0.469669914 L6.99398587,5.9333257 Z"
                                                            id="Combined-Shape"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </Button>
                                <Button disabled={this.state.disabled} color="primary"
                                        onClick={() => this.handleClick(0)}>0</Button>
                                <Button disabled={(this.state.countdown === true ? this.state.next !== true : true)}
                                        color="primary"
                                        onClick={() => this.handleClick('next')}>{t('next')}</Button>


                            </div>
                            <Dialog
                                open={this.state.showBlurDialog}
                                TransitionComponent={Transition}
                                keepMounted
                                aria-labelledby="alert-dialog-slide-title"
                                aria-describedby="alert-dialog-slide-description"
                            >
                                <DialogTitle
                                    id="alert-dialog-slide-title"> {t('returnFromBlurScreen.title')}</DialogTitle>
                                <DialogContent>
                                    <div style={{marginBottom: 30}}>{t('returnFromBlurScreen.text')}</div>
                                    <Button variant={'contained'} className={'block'} onClick={this.clickHandlerBlur}
                                            color="primary">
                                        {t('returnFromBlurScreen.buttonText')}
                                    </Button>
                                </DialogContent>

                            </Dialog>


                            <div className={'success-message'}>
                                <div className={'header'}>
                                    <div>
                                        <Typography variant="h4">
                                            {t('test')}
                                            <br/>
                                            {t('completed')}
                                        </Typography>
                                        <div className={'arrow'}>
                                            <svg viewBox="0 0 136.3 103" width="136px" height="103px">
                                                <polyline points="10.7,44.6 50.9,84.5 125.6,10.5 "></polyline>
                                                <polyline points="11.6,45.6 50.9,84.5 124.6,11.5 "></polyline>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className={'footer'}>
                                    <Button color="primary" onClick={() => {
                                        window.location.href = '/'
                                    }}>
                                        {t('overviewButton')}
                                    </Button>
                                </div>
                            </div>
                        </Container>
                    </Box>
                </div>

                {this.state.startTest ? <Dialog
                        open={this.state.setOpen}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogTitle id="alert-dialog-slide-title">{t('testPaused')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                {t('testPausedInfoMessage')}
                            </DialogContentText>
                            <Button onClick={this.handleClose} variant={'contained'} color={'primary'}
                                    className={'gray block'}>
                                {t('back')}
                            </Button>
                            <Button onClick={() => {
                                this.handleClose();
                                window.location.href = '/dashboard';
                            }} color="primary" variant="contained" className={'red block'}>
                                {t('abortTest')}
                            </Button>
                        </DialogContent>
                    </Dialog>
                    : <Dialog
                        open={this.state.setOpen}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogContent>
                            <div className={'iframe-wrap'}>
                                {this.state.setOpen ? <iframe width="560" height="315"
                                                              src="https://www.youtube-nocookie.com/embed/hFSbnr8KOpk?controls=0"
                                                              frameBorder="0"
                                                              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                              allowFullScreen></iframe> : ''}
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                {t('close')}
                            </Button>
                        </DialogActions>

                    </Dialog>}

            </div>
        );
    }
}

export default withTranslation()(withStyles(styles)(TrippleDigitTest));
